import { useCallback, useMemo } from "react";

import { getNextQueryParams } from "components/helpers";
import { ModalTable } from "components/BaseTableV3/ModalTable";
import DataJobService from "services/DataJob";
import {
  invalidateDataJobErrorsTableQuery,
  useDataJobErrorsTable,
} from "hooks/useDataJobErrorsTable";
import { omitByNil } from "helpers/tables";

export const DATA_JOB_ERRORS_TABLE_CONSTANTS = {
  tableName: "data_job_errors",
  queryKey: "data_job_errors",
  className: "DataJobErrors",
  exportTableName: "DataJobErrorsTable",
  header: "Import Validation Report",
  headerIcon: null,
};

const DataJobErrorsTableV3 = ({ dataJobId }) => {
  const defaultQueryParams = useMemo(
    () =>
      omitByNil({
        data_job_id: dataJobId,
      }),
    [dataJobId]
  );

  const { columns } = useDataJobErrorsTable({
    tableName: DATA_JOB_ERRORS_TABLE_CONSTANTS.tableName,
  });

  const fetchDataJobErrors = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        let response = await DataJobService.getDataJobErrors(
          dataJobId,
          nextQueryParams
        );

        return response;
      } catch (error) {
        console.error("Error fetching data job errors:", error);
        throw error;
      }
    },
    [columns, dataJobId]
  );

  return (
    <ModalTable
      columns={columns}
      header={DATA_JOB_ERRORS_TABLE_CONSTANTS.header}
      headerIcon={DATA_JOB_ERRORS_TABLE_CONSTANTS.headerIcon}
      queryKey={DATA_JOB_ERRORS_TABLE_CONSTANTS.queryKey}
      className={DATA_JOB_ERRORS_TABLE_CONSTANTS.className}
      exportTableName={DATA_JOB_ERRORS_TABLE_CONSTANTS.exportTableName}
      tableName={DATA_JOB_ERRORS_TABLE_CONSTANTS.tableName}
      fetchData={fetchDataJobErrors}
      invalidateData={invalidateDataJobErrorsTableQuery}
      downloadParams={defaultQueryParams}
    />
  );
};

export default DataJobErrorsTableV3;
